export default {
  email_confirm: {
    header: {
      title: 'Bestätigung der E-Mail-Adresse abgeschlossen',
    },
    completed: {
      section_one: 'Wir haben Ihre Anmelde-ID und Ihr Passwort an die von Ihnen angegebene E-Mail-Adresse geschickt. ',
      section_two: 'Prüfen Sie Ihre E-Mail und folgen Sie den Anweisungen in der E-Mail, um sich anzumelden.',
      section_three: 'Sollten Sie diese nach 30 Minuten noch nicht erhalten haben, benachrichtigen Sie uns bitte unter ',
      section_four: 'Der zuständige Mitarbeiter wird sich erneut mit Ihnen in Verbindung setzen.',
    },
    expired: {
      section_one: 'Die angegebene URL ist bereits abgelaufen',
      section_two: 'Wenn Sie diesen Service nutzen möchten, wenden Sie sich bitte an',
      section_three: 'Der zuständige Mitarbeiter wird sich mit Ihnen in Verbindung setzen.',
    },
    btn: {
      service_top: 'Nach oben',
      login: 'Anmelden',
      register: 'Registrieren',
      rating_url: 'https://asuene.com/rating/en',
    },
  },
}
